'use client';

import { c as _c } from "react/compiler-runtime";
import { Drawer } from '@/shared/components/ui/common/Drawer';
import { IconButton } from '@/shared/components/ui/common/IconButton';
import { FeatherX } from '@subframe/core';
const BLOCOS = [{
  titulo: '1 · Entidade única',
  texto: 'Cada documento padrão é um arquivo com metadados: tipo (procuração, carteira da OAB, contrato social, contrato, documento pessoal, outro), vínculo opcional a uma pessoa ou empresa por CPF/CNPJ, escopo, validade, produtos onde vale e histórico de uso.'
}, {
  titulo: '2 · Reuso por vínculo',
  texto: 'Quando o documento está vinculado a uma parte por CPF/CNPJ, os produtos passam a sugerir o arquivo certo sozinhos — sem ninguém abrir seletor. Documentos vencidos ou arquivados saem das sugestões.'
}, {
  titulo: '3 · Setor como permissão',
  texto: 'O escopo usa os setores que já existem no workspace: documento do escritório todos veem; documento de setor só quem pertence ao setor; pessoal só o autor. A mesma regra vale em todos os produtos.'
}];
interface DocumentosPadraoComoFuncionaDrawerProps {
  aberto: boolean;
  onFechar: () => void;
}
export function DocumentosPadraoComoFuncionaDrawer(t0) {
  const $ = _c(11);
  const {
    aberto,
    onFechar
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-heading-3 font-heading-3 text-default-font">Como funcionam os documentos padrão</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherX />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onFechar) {
    t3 = <div className="flex flex-none items-center justify-between border-b border-solid border-neutral-100 px-6 py-4">{t1}<IconButton variant="neutral-tertiary" icon={t2} onClick={onFechar} /></div>;
    $[2] = onFechar;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex grow flex-col gap-4 overflow-y-auto p-6"><p className="text-body font-body text-subtext-color">Uma única biblioteca por workspace, consumida por qualquer produto — notificação, negociação, mediação e arbitragem. Cadastre uma vez e, nos processos, você escolhe o que já existe em vez de subir arquivo de novo.</p>{BLOCOS.map(_temp)}</div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <Drawer.Content className="max-w-md"><div className="flex h-full w-full flex-col">{t3}{t4}</div></Drawer.Content>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== aberto || $[8] !== onFechar || $[9] !== t5) {
    t6 = <Drawer open={aberto} onOpenChange={onFechar}>{t5}</Drawer>;
    $[7] = aberto;
    $[8] = onFechar;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(bloco) {
  return <div key={bloco.titulo} className="flex flex-col gap-2 rounded-[16px] border border-solid border-neutral-200 p-4"><span className="text-caption-bold font-caption-bold text-subtext-color tracking-wider uppercase">{bloco.titulo}</span><p className="text-body font-body text-default-font">{bloco.texto}</p></div>;
}